export default "__VITE_ASSET__BmEKR4tK__"